<template>
  <!-- 扩容 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="expand"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <ul class="nav nav-tabs modal-tabs" id="myTab">
            <li class="active">
              <a
                data-toggle="tab"
                href="#expand-self"
                @click="switchTab('#expand-self')"
                >云盘扩容</a
              >
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#expand-group"
                @click="switchTab('#expand-group')"
                >群盘扩容</a
              >
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <div class="tab-content">
            <div class="tab-pane fade in active">
              <div class="prompt" v-show="activeTab === '#expand-group'">
                群盘空间，是您在所有群盘中共享的总空间。您可以在任意一个有权限的群盘里上传文件，所有群盘文件的合计使用空间，不能超过您的群盘空间大小。
              </div>

              <div class="form-group">
                <textarea
                  name="reason"
                  class="form-control"
                  placeholder="申请扩容说明"
                  rows="5"
                  style="resize: vertical"
                  v-model="form.reason"
                  data-vv-as="申请扩容说明 "
                  v-validate="{ required: true, max: 200 }"
                ></textarea>
                <span class="help-block" v-show="errors.has('reason')">{{
                  errors.first("reason")
                }}</span>
              </div>
              <div class="form-group">
                <div class="radiobox">
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="kr"
                        type="radio"
                        v-model="form.applySize"
                        value="107374182400"
                      />
                      <i></i>
                      100G
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="kr"
                        type="radio"
                        v-model="form.applySize"
                        value="214748364800"
                      />
                      <i></i>
                      200G
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="kr"
                        type="radio"
                        v-model="form.applySize"
                        value="536870912000"
                      />
                      <i></i>
                      500G
                    </label>
                  </div>
                  <div class="radio i-checks" v-if="false">
                    <label>
                      <input
                        name="kr"
                        type="radio"
                        v-model="form.applySize"
                        value="custom"
                      />
                      <i></i>
                      自定义
                    </label>
                  </div>
                </div>
                <div
                  class="customize"
                  style="width: 130px"
                  v-if="form.applySize === 'custom'"
                >
                  <div class="input-group">
                    <input
                      name="customSize"
                      class="form-control"
                      placeholder="自定义容量"
                      type="text"
                      v-model="form.customSize"
                      data-vv-as="自定义容量 "
                      v-validate="'numeric|max_value:10485760|min_value:10'"
                    />
                    <div class="input-group-btn">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-link dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        MB
                        <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                          <a>MB</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('customSize')">{{
                  errors.first("customSize")
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="extend">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from "@/api/drive/drive";
export default {
  name: "Expand",
  data() {
    return {
      form: {
        group_type: 0, // 0 个人盘 1 群盘
        applySize: 107374182400,
        reason: "",
        customSize: 1024,
      },
      activeTab: "#expand-self",
    };
  },
  methods: {
    switchTab(tabName) {
      this.form.group_type = tabName === "#expand-self" ? 0 : 1;
      this.activeTab = tabName;
      $('#myTab a[href="' + tabName + '"]').tab("show");
    },
    extend() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          extend(this.computedForm)
            .then((res) => {
              if (res.status_code === 200) {
                $("#expand").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.form = {
                  applySize: 107374182400,
                  reason: "",
                  customSize: 0,
                };
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
  },
  computed: {
    computedForm() {
      return {
        group_type: this.form.group_type,
        reason: this.form.reason.trim(),
        apply_size:
          this.form.applySize === "custom"
            ? this.form.customSize * 1024 * 1024 + ""
            : this.form.applySize + "",
      };
    },
  },
  mounted() {
    $("#expand").on("show.bs.modal", (event) => {
      const tab = $(event.relatedTarget).data("whatever");
      this.switchTab(tab);
    });
  },
};
</script>

<style scoped>
</style>